
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/[id]",
      function () {
        return require("private-next-pages/story/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story/[id]"])
      });
    }
  